<template>
    <div>
        <div class="errors" v-if="errors.length">
            <div v-for="error in errors" :key="error">
                <b-alert class="mt-4 mb-4" show variant="danger">
                    {{ error.code }} {{ error.title }}
                </b-alert >
            </div>
        </div>
        <div v-else-if="results.length">
            <h3 class="display-3 mb-2">You might also like</h3>
            <carousel :perPageCustom="[[0, 1], [768, 3], [1024, 4]]" :autoplay="true" :autoplayHoverPause="true" :paginationEnabled="false">
                <slide xs="4" v-for="result in results" :key="result.hotel.hotelId" class="m-2 align-self-stretch">
                    <b-card no-body class="h-100">
                        <b-carousel id="carousel-fade" controls :interval="0">
                            <template v-if="result.hotel.media">
                                <b-carousel-slide v-for="image in result.hotel.media" :key="image.url">
                                    <template v-slot:img>
                                        <div
                                            class="gallery"
                                            v-bind:style="{
                                                backgroundImage: 'url(' + image.uri + ')',
                                            }"
                                        />
                                    </template>
                                </b-carousel-slide>
                            </template>
                            <template v-else>
                                <b-carousel-slide>
                                    <template v-slot:img>
                                        <div class="placeholder-img gallery"></div>
                                    </template>
                                </b-carousel-slide>
                            </template>
                        </b-carousel>
                        <b-card-body>
                            <h3 class="hotel-title display-3 mb-0">
                                <router-link target='_blank' :to="{ path: '/' + $i18n.locale + '/hotel/' +  convertToSlug(result.hotel.name) + '/' + toHex(result.hotel.hotelId), query: $route.query }">
                                    {{ result.hotel.name }}
                                </router-link>
                            </h3>
                            <div class="rooms">
                                <div class="room" v-for="offer in result.offers" :key="offer.id">
                                    <Price :offer="offer" />
                                    <b-button variant="primary" target='_blank' :to="{ path: '/' + $i18n.locale + '/hotel/' +  convertToSlug(result.hotel.name) + '/' + toHex(result.hotel.hotelId), query: $route.query }">
                                        See availability
                                    </b-button>
                                </div>
                            </div>
                        </b-card-body>
                    </b-card>
                </slide>
            </carousel>
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import Price from '@/components/ui/Price'
    import { Carousel, Slide } from 'vue-carousel'

    export default {
        name: 'FeaturedHotels',
        components: {
            Price,
            Carousel,
            Slide,
        },
        data () {
            return {
                results: [],
                errors: [],
            }
        },
        props: {
            search: {
                type: Object,
                required: true
            }
        },
        methods: {
            loadResults() {
                
                let self = this;

                axios
                    .get('https://api.stay.com.de/?action=hotel-search' + 
                        '&lat=' + self.search.place.lat + 
                        '&lng=' + self.search.place.lng +
                        '&checkin=' + self.search.date.checkin +
                        '&checkout=' + self.search.date.checkout +
                        '&adults=' + self.search.occupation.adults +
                        '&children=' + self.search.occupation.children +
                        '&ages=' + JSON.stringify(self.search.occupation.ages) +
                        '&rooms=' + self.search.occupation.rooms +
                        '&sort=' + self.search.sort +
                        '&offset=' + self.offset +
                        '&mode=' + process.env.VUE_APP_MODE
                        
                    )
                    .then(function(response) {
                        if (response.data.data.length) {
                            self.results = self.results.concat(response.data.data);
                        } else {
                            self.noResult = true;
                        }

                        if (response.data.errors) {
                            self.errors = response.data.errors;
                        }
                    })
                ;
            },
            convertToSlug(text) {
                return text
                    .toLowerCase()
                    .replace(/[^\w ]+/g,'')
                    .replace(/ +/g,'-')
                ;
            },
            toHex(a) {
                var s = unescape(encodeURIComponent(a))
                var h = ''
                for (var i = 0; i < s.length; i++) {
                    h += s.charCodeAt(i).toString(16)
                }
                return h
            },
            capitalize(s) {
                if (typeof s !== 'string') return '';
                return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
            }
        },
        mounted () {
            this.loadResults();
        }
    }
</script>

<style scoped>
    .gallery{
        width:100%;
        height:150px;
        background-size:cover;
        background-repeat: no-repeat;
        background-position:50% 50%;
    }
    .placeholder-img{
        background-image:url('~@/assets/placeholder.jpg');
    }
</style>